import React from 'react';
import { platformApi } from '@/utils/platformApi';
import MfaSettingsPanel from '@/components/security/MfaSettingsPanel';
import UnlockAccountPanel from '@/components/security/UnlockAccountPanel';

export default function PlatformSecuritySettings() {
  return (
    <div className="space-y-10">
      <MfaSettingsPanel
        getStatus={() => platformApi.get('/auth/mfa/status')}
        startEnroll={() => platformApi.post('/auth/mfa/enroll/start', {})}
        verifyEnroll={(challengeId, code) => platformApi.post('/auth/mfa/enroll/verify', { challenge_id: challengeId, code })}
        disableMfa={(currentPassword) => platformApi.post('/auth/mfa/disable', { current_password: currentPassword })}
      />
      <UnlockAccountPanel
        unlockAccount={(email) => platformApi.post('/platform/admin/unlock-account', { email })}
      />
    </div>
  );
}
